const OFP_FACES = {
  Face1: {
    name: 'Face1',
    image: '/faces/Face1.jpg',
    id: 0,
  },
  Face2: {
    name: 'Face2',
    image: '/faces/Face2.jpg',
    id: 1,
  },
  Face3: {
    name: 'Face3',
    image: '/faces/Face3.jpg',
    id: 2,
  },
  Face4: {
    name: 'Face4',
    image: '/faces/Face4.jpg',
    id: 3,
  },
  Face5: {
    name: 'Face5',
    image: '/faces/Face5.jpg',
    id: 4,
  },
  Face6: {
    name: 'Face6',
    image: '/faces/Face6.jpg',
    id: 5,
  },
  Face7: {
    name: 'Face7',
    image: '/faces/Face7.jpg',
    id: 6,
  },
  Face8: {
    name: 'Face8',
    image: '/faces/Face8.jpg',
    id: 7,
  },
  Face9: {
    name: 'Face9',
    image: '/faces/Face9.jpg',
    id: 8,
  },
  Face10: {
    name: 'Face10',
    image: '/faces/Face10.jpg',
    id: 9,
  },
  Face11: {
    name: 'Face11',
    image: '/faces/Face11.jpg',
    id: 10,
  },
  Face12: {
    name: 'Face12',
    image: '/faces/Face12.jpg',
    id: 11,
  },
  Face13: {
    name: 'Face13',
    image: '/faces/Face13.jpg',
    id: 12,
  },
  Face14: {
    name: 'Face14',
    image: '/faces/Face14.jpg',
    id: 13,
  },
  Face15: {
    name: 'Face15',
    image: '/faces/Face15.jpg',
    id: 14,
  },
  Face16: {
    name: 'Face16',
    image: '/faces/Face16.jpg',
    id: 15,
  },
  Face17: {
    name: 'Face17',
    image: '/faces/Face17.jpg',
    id: 16,
  },
  Face18: {
    name: 'Face18',
    image: '/faces/Face18.jpg',
    id: 17,
  },
  Face19: {
    name: 'Face19',
    image: '/faces/Face19.jpg',
    id: 18,
  },
  Face20: {
    name: 'Face20',
    image: '/faces/Face20.jpg',
    id: 19,
  },
  Face21: {
    name: 'Face21',
    image: '/faces/Face21.jpg',
    id: 20,
  },
  Face22: {
    name: 'Face22',
    image: '/faces/Face22.jpg',
    id: 21,
  },
  Face23: {
    name: 'Face23',
    image: '/faces/Face23.jpg',
    id: 22,
  },
  Face24: {
    name: 'Face24',
    image: '/faces/Face24.jpg',
    id: 23,
  },
  Face25: {
    name: 'Face25',
    image: '/faces/Face25.jpg',
    id: 24,
  },
  Face26: {
    name: 'Face26',
    image: '/faces/Face26.jpg',
    id: 25,
  },
  Face27: {
    name: 'Face27',
    image: '/faces/Face27.jpg',
    id: 26,
  },
  Face28: {
    name: 'Face28',
    image: '/faces/Face28.jpg',
    id: 27,
  },
  Face29: {
    name: 'Face29',
    image: '/faces/Face29.jpg',
    id: 28,
  },
  Face30: {
    name: 'Face30',
    image: '/faces/Face30.jpg',
    id: 29,
  },
  Face31: {
    name: 'Face31',
    image: '/faces/Face31.jpg',
    id: 30,
  },
  Face32: {
    name: 'Face32',
    image: '/faces/Face32.jpg',
    id: 31,
  },
  Face33: {
    name: 'Face33',
    image: '/faces/Face33.jpg',
    id: 32,
  },
  Face34: {
    name: 'Face34',
    image: '/faces/Face34.jpg',
    id: 33,
  },
  Face35: {
    name: 'Face35',
    image: '/faces/Face35.jpg',
    id: 34,
  },
  Face36: {
    name: 'Face36',
    image: '/faces/Face36.jpg',
    id: 35,
  },
  Face37: {
    name: 'Face37',
    image: '/faces/Face37.jpg',
    id: 36,
  },
  Face38: {
    name: 'Face38',
    image: '/faces/Face38.jpg',
    id: 37,
  },
  Face39: {
    name: 'Face39',
    image: '/faces/Face39.jpg',
    id: 38,
  },
  Face40: {
    name: 'Face40',
    image: '/faces/Face40.jpg',
    id: 39,
  },
  Face41: {
    name: 'Face41',
    image: '/faces/Face41.jpg',
    id: 40,
  },
  Face42: {
    name: 'Face42',
    image: '/faces/Face42.jpg',
    id: 41,
  },
  Face43: {
    name: 'Face43',
    image: '/faces/Face43.jpg',
    id: 42,
  },
  Face44: {
    name: 'Face44',
    image: '/faces/Face44.jpg',
    id: 43,
  },
  Face45: {
    name: 'Face45',
    image: '/faces/Face45.jpg',
    id: 44,
  },
  Face46: {
    name: 'Face46',
    image: '/faces/Face46.jpg',
    id: 45,
  },
  Face47: {
    name: 'Face47',
    image: '/faces/Face47.jpg',
    id: 46,
  },
  Face48: {
    name: 'Face48',
    image: '/faces/Face48.jpg',
    id: 47,
  },
  Face49: {
    name: 'Face49',
    image: '/faces/Face49.jpg',
    id: 48,
  },
  Face50: {
    name: 'Face50',
    image: '/faces/Face50.jpg',
    id: 49,
  },
  Face51: {
    name: 'Face51',
    image: '/faces/Face51.jpg',
    id: 50,
  },
  Face52: {
    name: 'Face52',
    image: '/faces/Face52.jpg',
    id: 51,
  },
  FaceR01: {
    name: 'FaceR01',
    image: '/faces/FaceR01.jpg',
    id: 52,
  },
  FaceR02: {
    name: 'FaceR02',
    image: '/faces/FaceR02.jpg',
    id: 53,
  },
  FaceR03: {
    name: 'FaceR03',
    image: '/faces/FaceR03.jpg',
    id: 54,
  },
  FaceR04: {
    name: 'FaceR04',
    image: '/faces/FaceR04.jpg',
    id: 55,
  },
  Eva: {
    name: 'Eva',
    image: '/faces/Eva.jpg',
    id: 56,
  },
  Kamila: {
    name: 'Kamila',
    image: '/faces/Kamila.jpg',
    id: 57,
  },
  Lada: {
    name: 'Lada',
    image: '/faces/Lada.jpg',
    id: 58,
  },
  Lucie: {
    name: 'Lucie',
    image: '/faces/Lucie.jpg',
    id: 59,
  },
  Marketa: {
    name: 'Marketa',
    image: '/faces/Marketa.jpg',
    id: 60,
  },
  Nada: {
    name: 'Nada',
    image: '/faces/Nada.jpg',
    id: 61,
  },  
};

export default OFP_FACES;